import type { ObjectId } from '@racemap/sdk/schema/base';
import type { Immutable } from 'immer';
import { type FC, type PropsWithChildren, useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';

interface Props {
  rowId: string;
  selectionIds?: Immutable<Set<string | ObjectId>>;
  itemType: string;
  style: React.CSSProperties;
}

export const DraggableRow: FC<PropsWithChildren<Props>> = ({
  rowId,
  children,
  selectionIds,
  itemType,
  style,
}) => {
  const [collected, drag, dragPreview] = useDrag(
    () => ({
      type: itemType,
      item: {
        ids: selectionIds != null && selectionIds.size > 0 ? selectionIds : new Set([rowId]),
      },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
      isDragging: (monitor) => monitor.getItem().ids.has(rowId),
    }),
    [rowId, selectionIds],
  );
  const { isDragging, ...collectionRest } = collected;

  useEffect(() => {
    dragPreview(getEmptyImage(), { captureDraggingState: true });
  });

  return (
    <div style={{ opacity: isDragging ? 0.5 : 1, ...style }} ref={dragPreview}>
      <div ref={drag} {...collectionRest}>
        {children}
      </div>
    </div>
  );
};
